import _slicedToArray from "/var/jenkins_home/workspace/tingle.e49e9adf-d3ea-4dee-b9a2-f3d0e4982b89/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// ignore-string-externalization
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var LayoutContext = /*#__PURE__*/React.createContext({});
export function useLayoutContext() {
  return React.useContext(LayoutContext);
}
export var LayoutState = function LayoutState(_ref) {
  var children = _ref.children,
      _ref$preview = _ref.preview,
      preview = _ref$preview === void 0 ? false : _ref$preview;

  var _React$useState = React.useState(preview),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isPreview = _React$useState2[0],
      setIsPreview = _React$useState2[1];

  var _React$useState3 = React.useState(true),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      showNavBar = _React$useState4[0],
      setShowNavBar = _React$useState4[1];

  var _React$useState5 = React.useState(true),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      showFooter = _React$useState6[0],
      setShowFooter = _React$useState6[1];

  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      navBarBleed = _React$useState8[0],
      setNavBarBleed = _React$useState8[1];

  var _React$useState9 = React.useState(),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      navBarBackground = _React$useState10[0],
      setNavBarBackground = _React$useState10[1];

  var _React$useState11 = React.useState(),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      navBarTextColor = _React$useState12[0],
      setNavBarTextColor = _React$useState12[1];

  return /*#__PURE__*/_jsx(LayoutContext.Provider, {
    value: {
      showNavBar: showNavBar,
      showFooter: showFooter,
      navBarBackground: navBarBackground,
      navBarTextColor: navBarTextColor,
      navBarBleed: navBarBleed,
      isPreview: isPreview,
      setShowNavBar: setShowNavBar,
      setShowFooter: setShowFooter,
      setNavBarBackground: setNavBarBackground,
      setNavBarTextColor: setNavBarTextColor,
      setNavBarBleed: setNavBarBleed,
      setIsPreview: setIsPreview
    },
    children: children
  });
};